import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import OperatorDetail from 'system/components/operators/detail';
import { CommonOperatorCrumbs } from 'system/constants/common-operator-crumbs';
import { useNavigate } from 'react-router-dom';

const OperatorDetailPage = (): React.ReactElement => {
  const navigate = useNavigate();

  const onCancel = useCallback(() => {
    navigate('/sistema/operatori');
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonOperatorCrumbs, { name: 'Dettaglio Operatore' }]} />
      <OperatorDetail onCancel={onCancel} />
    </Fragment>
  );
};

OperatorDetailPage.displayName = 'Operator Edit page component';

export default OperatorDetailPage;
